import { z } from 'zod';

import { BookingOutcomeSchema } from '../booking/booking';

export const BOOKING_OUTCOME_NOTES_MAX_LENGTH = 2_000;

/**
 * Staff recording what happened at a meeting that was scheduled.
 *
 * The write half of {@link BookingOutcomeSchema}; the outcome values and the
 * argument for why cancellation is not among them live on the read contract, so
 * the two cannot drift.
 *
 * `notes` is where "she attended, he did not" is said. That is not a
 * lowest-common-denominator free-text box (U0): the attendance of two people at
 * a supervised meeting is genuinely narrative — somebody arrives late, leaves
 * early, brings a guardian nobody expected, or cancels at the door — and an enum
 * arm per combination would make staff choose the nearest wrong answer, which
 * reads as data and is not.
 */
export const BookingOutcomeRecordSchema = z
  .object({
    outcome: BookingOutcomeSchema,
    notes: z.string().trim().min(1).max(BOOKING_OUTCOME_NOTES_MAX_LENGTH).optional(),
  })
  .strict();

export type BookingOutcomeRecordRequest = z.infer<typeof BookingOutcomeRecordSchema>;
